export default __webpack_public_path__ + "static/media/xinfinnetworklogo.16efe7be.png";